import VarietyFilter from './VarietyFilter';

export default VarietyFilter;
